import Idiomas from "./Idiomas";

export default Idiomas;
